import React, { useEffect } from "react";
import "../../assets/style/CommonModal.css";

export default function CommonModal({ isOpen, onClose, title, children }) {
  // if (!isOpen) return null;


  return (
    <div className="creative-modal-wrapper"> 
      <div
        className="creative-modal-overlay"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
        onClick={onClose}
      >
        <div 
          className="creative-modal"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="creative-modal__accent"></div>
          <div className="creative-modal__content">
            <div className="creative-modal__header">
              <h2 className="creative-modal__heading" id="modal-title">
                {title}
              </h2>
              <button className="creative-modal__close" aria-label="Close modal" onClick={onClose}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
            <div className="creative-modal__main">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}